export default __webpack_public_path__ + "static/media/logo.57446546.svg";